<script setup lang="ts">
const { impersonatedCustomer } = useImpersonation()

defineEmits<{
  switchAccount: []
}>()
</script>

<template>
  <div class="p-3 bg-primary/10 dark:bg-primary/15 border border-primary/20 dark:border-primary/30 rounded-lg space-y-3">
    <!-- Header -->
    <div class="flex items-center gap-2 text-primary">
      <UIcon name="i-lucide-eye" class="w-4 h-4" />
      <span class="text-xs font-medium uppercase tracking-wide">Viewing as</span>
    </div>

    <!-- Customer Info -->
    <div class="min-w-0">
      <div class="flex items-center gap-2">
        <p class="font-medium text-default truncate">
          {{ impersonatedCustomer.customerName }}
        </p>
        <UBadge
          v-if="impersonatedCustomer.isTestAccount"
          color="warning"
          variant="subtle"
          size="xs"
        >
          Test
        </UBadge>
      </div>
      <p class="text-xs text-muted truncate">
        {{ impersonatedCustomer.customerEmail }}
      </p>
    </div>

    <!-- Actions -->
    <UButton
      size="xs"
      color="neutral"
      variant="outline"
      icon="i-lucide-repeat"
      block
      @click="$emit('switchAccount')"
    >
      Switch Account
    </UButton>
  </div>
</template>
